module.exports = __webpack_public_path__ + "media/theme/logo-f58bc411.png";